import type { RouteRecordRaw } from 'vue-router';
import { UUID_PATTERN_SOURCE } from '@/vue/common/constraints/uuid';
import ROUTE_NAMES from '@/vue/routes/routeNames';

const PlaylistPlaybackView = () => import('./views/PlaylistPlaybackView.vue');

export default [
    {
        path: `/playlist/:playlistId(${UUID_PATTERN_SOURCE})`,
        name: ROUTE_NAMES.REVIEW_PLAYLIST_VIEW,
        meta: {
            title: 'Review',
        },
        component: PlaylistPlaybackView,
        props: (route) => ({
            playlistId: String(route.params.playlistId),
        }),
    },
] satisfies RouteRecordRaw[];
